<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.invoiceInfo.title')}}
		</div>
		<div class="info">
			<ul>
				<li style="display: flex;">{{$t('mypages.invoiceInfo.label_invoice_type')}}
				<div class="tabBtns">
						<div class="tabBtn invoiceBtn"  :class="{active: invoice == 1}" @click="invoiceClick(1)"><div class="orange">{{$t('mypages.invoiceInfo.tab_short_special')}}</div>{{$t('mypages.invoiceInfo.tab_special')}}
					<img  src="../../assets/images/gou.png" v-if="invoice ==1"/>
					</div>
						<div class="tabBtn invoiceBtn"  :class="{active: invoice == 2}" @click="invoiceClick(2)"><div class="blue">{{$t('mypages.invoiceInfo.tab_short_general')}}</div>{{$t('mypages.invoiceInfo.tab_general')}}
					<img  src="../../assets/images/gou.png"  v-if="invoice ==2"/>
					</div>
				</div>
				</li>
				<li>{{$t('mypages.invoiceInfo.invoice_head')}} {{memberInfo.invoice_head}}</li>
				<li>{{$t('mypages.invoiceInfo.invoice_taxno')}} {{memberInfo.invoice_taxno}}</li>
				<li>{{$t('mypages.invoiceInfo.invoice_branch')}} {{memberInfo.invoice_branch}}</li>
				<li>{{$t('mypages.invoiceInfo.invoice_accountno')}} {{memberInfo.invoice_accountno}}</li>
				<li>{{$t('mypages.invoiceInfo.invoice_register_address')}}{{memberInfo.invoice_register_address}}</li>
				<li>{{$t('mypages.invoiceInfo.invoice_register_mobile')}}{{memberInfo.invoice_register_mobile}}</li>
			</ul>
			<div class="editBtn" @click="showPopup(memberInfo.id)">{{$t('mypages.invoiceInfo.edit')}}</div>
		</div>
		<PopupInvoice :visible="popupVisible"  :selectId="editInvoiceId"  @close="closePopup"></PopupInvoice>
	</div>
</template>

<script>
	import PopupInvoice from '../../components/popupInvoice.vue';
	export default{
		components:{
			PopupInvoice,
		},
		data(){
			return{ 
				memberInfo:{},
				editInvoiceId:0,
			}
		},
		created()
		{
			this.GetMemberInfo();
		},
		methods:{
			GetMemberInfo()
			{
				this.$scUtil.axiosPost(this, 'MemberApi/GetMemberInvoice', {
					userName: localStorage.getItem('username'),
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.memberInfo = res.data;
						this.invoice=this.memberInfo.invoice_type
						//console.log(JSON.stringify(this.memberInfo))
					}
				
				});
			}
			,showPopup(id){
				this.popupVisible = true;
				this.editInvoiceId=id;
			},
			closePopup(){
				this.popupVisible = false;
				this.GetMemberInfo();
			},
		}
	}
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}	
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	.info{
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		background-color: #fff;
	}
	
	.info ul li{
		font-size: 13px;
		color: #333333;
		line-height: 40px;
		list-style: none;
	}
	
	.editBtn{
		width: 117px;
		height: 33px;
		background-color: #0380fe;
		color: #fff;
		font-size: 13px;
		text-align: center;
		line-height: 33px;
		margin-top: 15px;
		border-radius: 3px;
	}
	.tabBtns{
		display: flex;
		align-items: center;
	}
	
	.tabBtn{
		height: 30px;
		line-height: 30px;
		padding: 0 17px;
		font-size: 14px;
		color: #333333;
		border: 1px solid #cccccc;
		border-radius: 5px;
		position: relative;
		margin-right: 18px;
	}
	
	.tabBtn.active{
		border: 1px solid #0380fe;
	}
	
	.tabBtn img{
		position: absolute;
		bottom: 0px;
		right: 0px;
	}
	
	.invoiceBtn{
		display: flex;
		align-items: center;
	}
	
	
	.invoiceBtn .orange{
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #ff8d50;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}
	
	.invoiceBtn .blue{
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #0380fe;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}
</style>